import { toast } from "react-toastify";
import {
    CREATE_POST_REQUEST,
    CREATE_POST_SUCCESS,
    CREATE_POST_FAIL,
    CLEAR_ERRORS,
    ALL_POSTS_REQUEST,
    ALL_POSTS_SUCCESS,
    ALL_POSTS_FAIL,
    CHANGE_STATUS_REQUEST,
    CHANGE_STATUS_SUCCESS,
    CHANGE_STATUS_FAIL,
    SAVED_POSTS_REQUEST,
    SAVED_POSTS_SUCCESS,
    SAVED_POSTS_FAIL,
    LIKED_POSTS_SUCCESS,
    LIKED_POSTS_REQUEST,
    SAVED_PLANS_REQUEST,
    SAVED_PLANS_SUCCESS,
    SAVED_PLANS_FAIL,
} from "../constants/postConstants";
import {
    SEARCH_POST_REQUEST,
    SEARCH_POST_FAIL,
    SEARCH_POST_SUCCESS,
} from "../constants/searchConstants";
import axios from "axios";
import config from "../config";

const axiosconfig = {withCredentials:true};

const serverurl = config.apiUrl;
const serverConfig = {
    withCredentials:true,
}
//get all posts
export const getAllPosts = (currentPage = 1, category = "") => async (dispatch) => {
  try {
    dispatch({ type: ALL_POSTS_REQUEST });

    const categoryParam = category ? `&category=${category}` : "";
    const response = await axios.get(
      `${serverurl}/api/v1/mynotes?page=${currentPage}${categoryParam}`,
      serverConfig
    );

    const { data: { postToSend, postCount } } = response;
    dispatch({ type: ALL_POSTS_SUCCESS, payload: { postToSend, postCount } });
    return response;
  } catch (error) {
    dispatch({ type: ALL_POSTS_FAIL, payload: error.response.data.message });
    toast.error(error.statusText);
    return error.response;
  }
};

//Like post
export const likePost = (postData) => async(dispatch) => {
    try{
        const response = await axios.post(`${serverurl}/api/v1/like-post`, postData,serverConfig);
        const {data:{likedPosts}} = response;
        // const likedpostarray = likedPosts.map((savedPost) => savedPost.post);
        dispatch({type: LIKED_POSTS_SUCCESS, payload: likedPosts});
        return response.data.message;
    }catch(error){
        toast.error("Something went wrong. Try again");
    }
}
//Save post
export const savePost = (postData) => async(dispatch) => {
    try{
        const response = await axios.post(`${serverurl}/api/v1/save-post`, postData,serverConfig);
        const {data:{savedPosts}} = response;
        const savedpostarray = savedPosts.map((savedPost) => savedPost.post);
        dispatch({type: SAVED_POSTS_SUCCESS, payload: savedpostarray});
        return response.data.message;
    }catch(error){
        toast.error("Something went wrong. Try again");
    }
}

//get Liked posts
export const getLikedPosts = () => async(dispatch) => {
    try{
        dispatch({type: LIKED_POSTS_REQUEST});
        const response = await axios.get(`${serverurl}/api/v1/liked`,serverConfig);
        const {data:{likedPosts}} = response;
        // const likedpostarray = likedPosts.map((likedPost) => likedPost.post);
        dispatch({type: LIKED_POSTS_SUCCESS, payload: likedPosts});
    }catch(error){
        dispatch({type: SAVED_POSTS_FAIL});
        toast.error("Something went wrong. Try again");
    }
}//get Saved posts
export const getSavedPosts = () => async(dispatch) => {
    try{
        dispatch({type: SAVED_POSTS_REQUEST});
        const response = await axios.get(`${serverurl}/api/v1/saved`,serverConfig);
        const {data:{savedPosts}} = response;
        const savedpostarray = savedPosts.map((savedPost) => savedPost.post);
        dispatch({type: SAVED_POSTS_SUCCESS, payload: savedpostarray});
    }catch(error){
        dispatch({type: SAVED_POSTS_FAIL});
        toast.error("Something went wrong. Try again");
    }
}

// toggle save/unsave a vision
export const savePlan = (planId) => async (dispatch) => {
    try {
        const response = await axios.post(`${serverurl}/api/v1/save-plan`, { planId }, serverConfig);
        const { data: { savedPlans, saved } } = response;
        const plans = savedPlans.map((sp) => sp.plan);
        dispatch({ type: SAVED_PLANS_SUCCESS, payload: plans });
        return saved;
    } catch (error) {
        toast.error("Something went wrong. Try again");
    }
};

// get all saved visions
export const getSavedPlans = () => async (dispatch) => {
    try {
        dispatch({ type: SAVED_PLANS_REQUEST });
        const response = await axios.get(`${serverurl}/api/v1/saved-plans`, serverConfig);
        const { data: { savedPlans } } = response;
        const plans = savedPlans.map((sp) => sp.plan);
        dispatch({ type: SAVED_PLANS_SUCCESS, payload: plans });
    } catch (error) {
        dispatch({ type: SAVED_PLANS_FAIL, payload: error?.response?.data?.message });
        toast.error("Something went wrong. Try again");
    }
};

//create post
export const createPost = (postData) => async(dispatch) => {
    try{
        dispatch({type: CREATE_POST_REQUEST});
        // console.log("sending post request");
        // console.log(postData);
        const response = await axios.post(
            `${serverurl}/api/v1/createpost`,
            postData,
            serverConfig
        );
        const {data: {post}} = response;
        dispatch({type: CREATE_POST_SUCCESS, payload: post});
        return post;
    } catch(error){
        dispatch({type: CREATE_POST_FAIL, payload: error.response.data.message});
        toast.error("Something went wrong. Try again");
    }
  };


 // ===============================
// CREATE 5 YEAR PLAN
// ===============================
export const createYearlyPlan = (planData) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_YEARLY_PLAN_REQUEST" });

    const response = await axios.post(
      `${serverurl}/api/v1/yearly-plan`,
      planData,
      serverConfig
    );

    const { planId, nodeIds = [] } = response.data;

    dispatch({
      type: "CREATE_YEARLY_PLAN_SUCCESS",
      payload: planId
    });

    return { planId, nodeIds };
  } catch (error) {
    const status = error.response?.status;
    const message = error.response?.data?.message;

    dispatch({
      type: "CREATE_YEARLY_PLAN_FAIL",
      payload: message
    });

    if (status !== 401) {
      toast.error(message || "Failed to create 5 year plan");
    }

    return { error: true, status };
  }
};

// ===============================
// PATCH plan name + duration
// ===============================
export const updateYearlyPlanMeta = ({ id, name, heading, description, category, durationInYears }) => async (dispatch, getState) => {
  try {
    const body = {};
    if (typeof name === "string") body.name = name;
    if (typeof heading === "string") body.heading = heading;
    if (typeof description === "string") body.description = description;
    if (typeof category === "string") body.category = category;
    if (typeof durationInYears === "number") body.durationInYears = durationInYears;
    const { data } = await axios.patch(
      `${serverurl}/api/v1/yearly-plan/${id}`,
      body,
      serverConfig
    );
    const currentPlan = getState().yearlyPlan?.plan;
    dispatch({
      type: "GET_YEARLY_PLAN_SUCCESS",
      payload: { ...currentPlan, ...data.plan },
    });
    return data.plan;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to update plan");
    return null;
  }
};

// ===============================
// GET 5 YEAR PLAN
// ===============================
export const getYearlyPlan = (planId) => async (dispatch) => {
  try {
    dispatch({ type: "GET_YEARLY_PLAN_REQUEST" });
    
    const response = await axios.get(
      `${serverurl}/api/v1/yearly-plan/${planId}`,
      serverConfig
    );
    
    dispatch({
      type: "GET_YEARLY_PLAN_SUCCESS",
      payload: response.data.plan
    });

    return response.data.plan;
  } catch (error) {
    dispatch({
      type: "GET_YEARLY_PLAN_FAIL",
      payload: error.response?.data?.message
    });

    toast.error(error.response?.data?.message);
  }
};

    // ===============================
// CREATE POST FOR 5 YEAR PLAN
// ===============================
export const createPostForPlan = (data) => async (dispatch) => {
  try {
    const { planId, ...payload } = data;
    if (!planId) {
      throw new Error("Plan ID is required");
    }

    const response = await axios.post(
      `${serverurl}/api/v1/plan/${planId}/post`,
      data,
      serverConfig
    );

    // We intentionally do NOT dispatch to reducer here
    // The plan view refetches data and stays source-of-truth

    return response.data.post;
  } catch (error) {
    toast.error("Something went wrong while adding node to plan");
  }
};

export const getMyYearPlans = () => async (dispatch) => {
  try {
    dispatch({ type: "MY_YEAR_PLANS_REQUEST" });
    const { data } = await axios.get(`${serverurl}/api/v1/year-plans/mine`, serverConfig);
    dispatch({
      type: "MY_YEAR_PLANS_SUCCESS",
      payload: data.plans,
    });
  } catch (error) {
    dispatch({
      type: "MY_YEAR_PLANS_FAIL",
      payload: error.response?.data?.message || "Failed to load plans",
    });
  }
};

  //addupdate\
  export const addUpdate = (data, setpost) => async(dispatch) => {
    try{
        const {data:{post}} = await axios.post(`${serverurl}/api/v1/addupdate`, data, serverConfig);
        setpost(post);
        // console.log(post);
    }catch(error){
        toast.error("Something went wrong. Try again");
    }
  }

  //delete post
  export const deletePost = (data) => async(dispatch) => {
    try{
    const response = await axios.post(`${serverurl}/api/v1/delete`, data, serverConfig);
    return response.data;
    }catch(error){
        return error.response.data;
    }
  }

  //Searchpost
 export const searchPost = (searchTerm, sort = "new", currentPage, category = "") => async (dispatch) => {
  try {
    dispatch({ type: SEARCH_POST_REQUEST });
    const link = `${serverurl}/api/v1/search?keyword=${searchTerm}&sort=${sort}&page=${currentPage}&category=${category}`;
    const { data } = await axios.get(link);
    dispatch({ type: SEARCH_POST_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: SEARCH_POST_FAIL });
    toast.error("Something went wrong. Try again");
    return { posts: [] };
  }
};


  //change status
  export const changeStatus = (postId) => async(dispatch) => {
    try{
        dispatch({type: CHANGE_STATUS_REQUEST});
        const response = await axios.post(
            `${serverurl}/api/v1/changestatus`,
            postId,
            serverConfig
        );
        const{data:{post}} = response;
        dispatch({type: CHANGE_STATUS_SUCCESS, payload: post});
        return response.data;
        
    }catch(error){
        dispatch({type: CHANGE_STATUS_FAIL, payload: error.response.data.message});
        toast.error("Something went wrong. Try again");
    }
  }

  export const changeVisibility = (data) => async(dispatch) => {
    try{
        const response = await axios.post(
            `${serverurl}/api/v1/changevisibility`,
            data,
            serverConfig
            );
            // console.log(response);
            return response;
    }catch(error){
        return error.response;
    }
  }

  export const clearErrors = () => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
  };
  
// ===============================
// TOGGLE PRIORITY NODE
// ===============================
export const togglePriority = (postId, isPriority) => async (dispatch) => {
  try {
    dispatch({ type: "TOGGLE_PRIORITY_REQUEST", payload: postId });

    if (isPriority) {
      await axios.delete(
        `${serverurl}/api/v1/post/priority`,
        {
          data: { postId },
          ...serverConfig
        }
      );
    } else {
      await axios.post(
        `${serverurl}/api/v1/post/priority`,
        { postId },
        serverConfig
      );
    }

    dispatch({
      type: "TOGGLE_PRIORITY_SUCCESS",
      payload: { postId, isPriority: !isPriority }
    });

    return true;
  } catch (error) {
    dispatch({
      type: "TOGGLE_PRIORITY_FAIL",
      payload:
        error.response?.data?.message ||
        "Failed to update priority"
    });

    toast.error(
      error.response?.data?.message ||
      "Failed to update priority"
    );

    return false;
  }
};
export const exploreByCategory = (params) => async (dispatch) => {
  try {
    const { category = "all", sort = "recent", page = 1 } = params;
    const response = await axios.get(
      `${serverurl}/api/v1/explore?category=${category}&sort=${sort}&page=${page}`,
      serverConfig
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getExploreCategories = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${serverurl}/api/v1/explore/categories`,
      serverConfig
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
export const searchYearlyPlans = (keyword = "", page = 1) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${serverurl}/api/v1/plans/search?keyword=${keyword}&page=${page}`,
      serverConfig
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
